export default "__VITE_ASSET__iLZzCUH5__"